var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1fz4up9" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  margin-bottom: 8px;\n"], ["\n  display: flex;\n\n  margin-bottom: 8px;\n"])));
var Number = styled.span.withConfig({ displayName: "Number", componentId: "sc-15h68xu" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n"], ["\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var NumberUnit = function (_a) {
    var number = _a.number;
    return (_jsx(Container, { children: _jsx(Number, { children: "Class number: " + number }, void 0) }, void 0));
};
export { NumberUnit };
var templateObject_1, templateObject_2;
